import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import NumberFormat from "react-number-format";

import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import DialogAlert from "../../../../../components/dialog/DialogAlert";
import ButtonDefault from "../../../../../components/button/ButtonDefault";

import { UploadAndEditThumbnail } from "../../../../../components/upload/uploadAndEditThumbnail ";

import {
  updateProductAction,
  addProductAction,
  resetStateServiceAction,
} from "../../../../../../redux/action/serviceAction";

function ProductDetailForm(props) {
  const { dataProduct, type } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const statusDropdown = [
    { name: "Artikel", code: "article" },
    { name: "Press Release", code: "pr" },
    { name: "Sebar Rilis", code: "sebar_rilis" },
  ];
  const isDetailPage = type === "detailpage";

  const [nameState, setNameState] = useState({ value: "", error: null });
  const [imageState, setImageState] = useState({ value: null, error: null });
  const [categoryState, setCategoryState] = useState({
    value: "",
    error: null,
  });
  const [noteState, setNoteState] = useState({ value: "", error: null });
  const [noteDetailState, setNoteDetailState] = useState({
    value: "",
    error: null,
  });
  const [priceState, setPriceState] = useState({ value: "", error: null });
  const [priceDiscountState, setPriceDiscountState] = useState({
    value: "",
    error: null,
  });
  const [featureState, setFeatureState] = useState({
    value: false,
    error: null,
  });
  const [loadingState, setLoadingState] = useState(false);
  const [dialogAlert, setDialogAlert] = useState({
    type: "",
    dialog: false,
    title: "",
    text: "",
  });

  const {
    successUpdateProduct,
    errUpdateProduct,
    successAddProduct,
    errAddProduct,
  } = useSelector((state) => state.service);
  const { successUploadImage, dataUploadImage } = useSelector(
    (state) => state.utils
  );

  const toolbarOptions = [
    ["bold", "italic", "underline"],
    [{ header: [1, 2, 3, 4, 5, false] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
  ];

  const imagesSize = {
    quality: 0.5,
    maxWidth: 500,
    maxHeight: 500,
    imageType: "image/jpeg",
    debug: true,
  };

  const modules = {
    toolbar: toolbarOptions,
    imageCompress: imagesSize,
  };

  const changeNoteDetail = (value) => {
    setNoteDetailState({
      value,
      error: null,
    });
  };

  useEffect(() => {
    if (successUploadImage) {
      setImageState({ error: null, value: dataUploadImage });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successUploadImage]);

  useEffect(() => {
    if (dataProduct !== null) {
      setNameState({ ...nameState, value: dataProduct?.name });
      setCategoryState({ ...categoryState, value: dataProduct?.category });
      setNoteState({ ...noteState, value: dataProduct?.description });
      setNoteDetailState({
        ...noteDetailState,
        value: dataProduct?.descriptionDetail,
      });
      setPriceState({ ...priceState, value: dataProduct?.price });
      setPriceDiscountState({
        ...priceDiscountState,
        value: dataProduct?.priceDiscount,
      });
      setFeatureState({
        ...featureState,
        value: dataProduct?.feature,
      });
      if (dataProduct?.image) {
        setImageState({ ...imageState, value: dataProduct?.image });
      } else {
        setImageState({
          ...imageState,
          value: isDetailPage ? process.env.REACT_APP_IMAGE_ARTICLE : null,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataProduct]);

  useEffect(() => {
    if (successAddProduct) {
      setTimeout(() => {
        setLoadingState(false);
        setDialogAlert({
          dialog: true,
          type: "success",
          title: "Berhasil Menambahkan Data!",
          text: "Data produk berhasil disimpan",
        });
      }, 2000);
    }
    if (errAddProduct) {
      setLoadingState(false);
      setDialogAlert({
        dialog: true,
        type: "error",
        title: "Gagal Menambahkan Data!",
        text: "Data produk gagal disimpan",
      });
    }
  }, [successAddProduct, errAddProduct]);

  useEffect(() => {
    if (successUpdateProduct) {
      setTimeout(() => {
        setLoadingState(false);
        setDialogAlert({
          dialog: true,
          type: "success",
          title: "Berhasil Mengubah Data",
          text: "Data produk berhasil diubah",
        });
      }, 2000);
    }
    if (errUpdateProduct) {
      setLoadingState(false);
      setDialogAlert({
        dialog: true,
        type: "error",
        title: "Gagal Mengubah Data",
        text: "Data produk gagal diubah",
      });
    }
  }, [successUpdateProduct, errUpdateProduct]);

  const submitData = () => {
    const data = {
      name: nameState?.value,
      price: priceState?.value,
      priceDiscount: priceDiscountState?.value,
      description: noteState?.value,
      descriptionDetail: noteDetailState?.value,
      category: categoryState.value,
      image: imageState.value,
      feature: featureState.value,
    };

    if (nameState.value.length < 1) {
      setNameState({ ...nameState, error: "Nama harus diisi" });
    }
    if (categoryState.value.length < 1) {
      setCategoryState({ ...categoryState, error: "Kategori harus diisi" });
    }
    if (priceState.value.length < 1) {
      setPriceState({ ...priceState, error: "Harga harus diisi" });
    }
    if (!priceState.value.match(/^[0-9]+$/)) {
      setPriceState({ ...priceState, error: "Harga tidak valid" });
    }

    if (priceDiscountState.value.length > 1) {
      if (!priceDiscountState.value.match(/^[0-9]+$/))
        setPriceDiscountState({
          ...priceDiscountState,
          error: "Harga diskon tidak valid",
        });
    }

    if (noteState.value.length < 1) {
      setNoteState({ ...noteState, error: "Deskripsi singkat harus diisi" });
    }

    if (noteDetailState.value.length < 1)
      setNoteDetailState({
        ...noteDetailState,
        error: "Deskripsi detail harus diisi",
      });

    if (imageState.value === null) {
      setImageState({ ...imageState, error: "Gambar Thumbnail harus diisi" });
    }

    if (
      nameState.value.length > 0 &&
      categoryState.value.length > 0 &&
      priceState.value.length > 0 &&
      priceState.value.match(/^[0-9]+$/) &&
      noteState.value.length > 0 &&
      noteDetailState.value.length > 0 &&
      imageState.value !== null
    ) {
      setLoadingState(true);
      if (type === "createpage") {
        dispatch(addProductAction(data));
      } else {
        dispatch(updateProductAction(props.productId, data));
      }
    }
  };

  const closeDialog = () => {
    if (dialogAlert.type === "success") {
      setDialogAlert({ type: "", dialog: false, title: "", text: "" });
      dispatch(resetStateServiceAction());
      history.push("/admin/pm/list-product");
    } else {
      setDialogAlert({ type: "", dialog: false, title: "", text: "" });
      dispatch(resetStateServiceAction());
    }
  };

  let categoryValue = "Artikel";
  if (categoryState.value === "pr") {
    categoryValue = "Press Realese";
  } else if (categoryState.value === "distribution_media") {
    categoryValue = "Media Distribusi";
  } else if (categoryState.value === "sebar_rilis") {
    categoryValue = "Sebar Rilis";
  } else {
    categoryValue = "Artikel";
  }

  return (
    <>
      <div className="card-body pt-0 pb-4 p-d-flex p-jc-center">
        <div className="form-detail-pm col-10">
          <div className="p-field">
            <label className="p-d-block">
              Foto Thumbnail Produk
              {!isDetailPage && <span className="text-danger">*</span>}
            </label>
            <UploadAndEditThumbnail
              attachment={imageState.value}
              displayOnly={isDetailPage}
              path={"products"}
              errorText={imageState.error}
              deleteImage={() => setImageState({ error: null, value: null })}
            />
          </div>
          <div className="p-field">
            <label className="p-d-block">
              Kategori Produk
              {!isDetailPage && <span className="text-danger">*</span>}
            </label>
            {isDetailPage ? (
              <p>{categoryValue}</p>
            ) : (
              <>
                <Dropdown
                  value={categoryState.value}
                  options={statusDropdown}
                  onChange={(e) =>
                    setCategoryState({
                      error: null,
                      value: e.target.value,
                    })
                  }
                  optionLabel="name"
                  optionValue="code"
                  placeholder="Pilih Kategori Project"
                  className={`full-width ${categoryState.error && "p-invalid"}`}
                />
                {categoryState.error && (
                  <small id="name" className="p-error p-d-block p-text-right">
                    {categoryState.error}
                  </small>
                )}
              </>
            )}
          </div>
          <div className="p-field">
            <label className="p-d-block">
              Nama Produk
              {!isDetailPage && <span className="text-danger">*</span>}
            </label>
            {isDetailPage ? (
              <p>{nameState.value}</p>
            ) : (
              <>
                <InputText
                  type="text"
                  className={`p-d-block ${nameState.error && "p-invalid"}`}
                  placeholder="Masukkan Nama Produk"
                  value={nameState.value}
                  onChange={(e) =>
                    setNameState({
                      error: null,
                      value: e.target.value,
                    })
                  }
                />
                {nameState.error && (
                  <small id="name" className="p-error p-d-block p-text-right">
                    {nameState.error}
                  </small>
                )}
              </>
            )}
          </div>
          <div className="p-field">
            <label className="p-d-block">
              Keterangan Singkat Produk
              {!isDetailPage && <span className="text-danger">*</span>}
            </label>
            {isDetailPage ? (
              <p>{noteState.value}</p>
            ) : (
              <>
                <InputTextarea
                  rows={5}
                  cols={30}
                  value={noteState.value}
                  onChange={(e) =>
                    setNoteState({
                      error: null,
                      value: e.target.value,
                    })
                  }
                  placeholder="Masukkan Keterangan Singkat Produk"
                  className={`p-d-block ${noteState.error && "p-invalid"}`}
                />
                {noteState.error && (
                  <small id="name" className="p-error p-d-block p-text-right">
                    {noteState.error}
                  </small>
                )}
              </>
            )}
          </div>
          <div className="p-field">
            <label className="p-d-block">
              Keterangan Detail Produk
              {!isDetailPage && <span className="text-danger">*</span>}
            </label>
            {isDetailPage ? (
              <div
                dangerouslySetInnerHTML={{ __html: noteDetailState.value }}
              />
            ) : (
              <div className="p-field border rounded">
                <ReactQuill
                  className="textarea-content"
                  value={noteDetailState.value}
                  onChange={changeNoteDetail}
                  modules={modules}
                  placeholder="Masukkan Keterangan Detail Produk"
                />
              </div>
            )}
          </div>
          <div className="p-field">
            <label className="p-d-block">
              Harga{!isDetailPage && " (Rp)"}
              {!isDetailPage && <span className="text-danger">*</span>}
            </label>
            {isDetailPage ? (
              <NumberFormat
                prefix={"Rp "}
                thousandSeparator={"."}
                decimalSeparator={","}
                displayType="text"
                value={priceState.value}
                renderText={(value) => <p>{value}</p>}
              />
            ) : (
              <>
                <InputText
                  type="text"
                  className={`p-d-block ${priceState.error && "p-invalid"}`}
                  placeholder="Masukkan Harga"
                  value={priceState.value}
                  onChange={(e) =>
                    setPriceState({
                      error: null,
                      value: e.target.value,
                    })
                  }
                />
                {priceState.error && (
                  <small id="name" className="p-error p-d-block p-text-right">
                    {priceState.error}
                  </small>
                )}
              </>
            )}
          </div>
          <div className="p-field">
            <label className="p-d-block">
              Harga Diskon{!isDetailPage && " (Rp)"}
            </label>
            {isDetailPage ? (
              <NumberFormat
                prefix={"Rp "}
                thousandSeparator={"."}
                decimalSeparator={","}
                displayType="text"
                value={priceDiscountState.value}
                renderText={(value) => <p>{value}</p>}
              />
            ) : (
              <>
                <InputText
                  type="text"
                  className={`p-d-block ${priceDiscountState.error &&
                    "p-invalid"}`}
                  placeholder="Masukkan Harga Diskon"
                  value={priceDiscountState.value}
                  onChange={(e) =>
                    setPriceDiscountState({
                      error: null,
                      value: e.target.value,
                    })
                  }
                />
                {priceDiscountState.error && (
                  <small id="name" className="p-error p-d-block p-text-right">
                    {priceDiscountState.error}
                  </small>
                )}
              </>
            )}
          </div>
          <div className="p-field d-flex align-items-center justify-content-between">
            <label className="col-form-label">Feature</label>
            <div>
              <span className="switch">
                <label>
                  <input
                    type="checkbox"
                    defaultChecked={featureState.value}
                    name="select"
                    onClick={() =>
                      setFeatureState({
                        error: null,
                        value: !featureState.value,
                      })
                    }
                    disabled={isDetailPage}
                  />
                  <span></span>
                </label>
              </span>
            </div>
          </div>
        </div>
      </div>
      {!isDetailPage && (
        <div className="company footer-form">
          <div className="form-add-project col-10 p-d-flex p-jc-end p-ai-center">
            <ButtonDefault
              className="mr-2 p-button p-button-secondary"
              label="BATAL"
              onClick={() => history.goBack()}
              disabled={loadingState}
              type="bordered"
            />
            <ButtonDefault
              onClick={() => submitData()}
              label={type === "createpage" ? "SIMPAN" : "EDIT"}
              className="ml-2 p-button p-button-primary"
              loading={loadingState}
            />
          </div>
        </div>
      )}

      <DialogAlert
        type={dialogAlert.type}
        visible={dialogAlert.dialog}
        closeDialog={() => closeDialog()}
        title={dialogAlert.title}
        text={dialogAlert.text}
      />
    </>
  );
}

export default ProductDetailForm;
